import { getIsConsentOrPay } from '../isConsentOrPay.js';
import { SourcePointChoiceTypes } from './sourcepointConfig.js';
const getOphanRecordFunction = () => {
    const record = window.guardian?.ophan?.record;
    if (record) {
        return record;
    }
    console.log("window.guardian.ophan.record is not available");
    return () => {
    };
};
const constructBannerMessageId = (messageId) => {
    const messageType = getIsConsentOrPay() ? "CONSENT_OR_PAY_BANNER" : "ACCEPT_REJECT";
    return `${messageType}-${messageId}`;
};
const sendConsentChoicesToOphan = (choiceType, messageId) => {
    let actionValue;
    switch (choiceType) {
        case SourcePointChoiceTypes.AcceptAll:
            actionValue = "accept";
            break;
        case SourcePointChoiceTypes.RejectAll:
            actionValue = "reject";
            break;
        case SourcePointChoiceTypes.Dismiss:
            actionValue = "dismiss";
            break;
        case SourcePointChoiceTypes.ManageCookies:
            actionValue = "manage-cookies";
            break;
    }
    const componentEvent = {
        component: {
            componentType: "CONSENT",
            id: messageId
        },
        action: "CLICK",
        value: actionValue
    };
    const record = getOphanRecordFunction();
    record({ componentEvent });
};
const sendMessageReadyToOphan = (messageId) => {
    const componentEvent = {
        component: {
            componentType: "CONSENT",
            id: messageId
        },
        action: "VIEW"
    };
    const record = getOphanRecordFunction();
    record({ componentEvent });
};
export { constructBannerMessageId, sendConsentChoicesToOphan, sendMessageReadyToOphan };
